import { render } from "./PitcherProjections.vue?vue&type=template&id=2bbbc200"
import script from "./PitcherProjections.vue?vue&type=script&lang=js"
export * from "./PitcherProjections.vue?vue&type=script&lang=js"

import exportComponent from "/Users/danielseguin/Documents/Websites/ootp-calculator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__